import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';

import moment from 'moment';
import * as commonVar from 'libs/commonVar';

import {
  Loading,
  StartExamWizardContentStep1,
  StartExamWizardContentStep2,
  StartExamWizardContentStep3,
  StartExamWizardContentStep4,
  StartExamWizardContentStep5
} from 'components';

import classNames from 'classnames/bind';
import styles from './StartExam.css';
const cx = classNames.bind(styles);

class StartExamWizardContent extends Component {
  constructor(props) {
    super(props);

    this.targetSelected = false;
    this.rejectEmailPoint = 0;

    this.state = {
      startDate: null,
      endDate: null,
      attachScreenLockDate: null,
      loadingTargetTag: false,
      loadingTemplate: false,
      targetSelectCount: '',
      templateSelectCount: '',
      reactivateValidate: '',
      isAttachScreenView: false,
      tempName: []
    };

    this.handleDatePickerOnChangeStart = this.handleDatePickerOnChangeStart.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { step, formStore } = nextProps;

    if (step === 1 && this.state.reactivateValidate === '') {
      // redux-form reset 후 change 이벤트 발생 전까지는 validate 동작이 안되는 것에 대한 임시 보완책
      this.setState({ reactivateValidate: 'colap' });
    } else if (step === 3 && formStore) {
      const { forceViewError, tagData } = nextProps;

      let mustApply = 0;
      let targetSelectCount = 0;
      if (
        formStore.registeredFields &&
        formStore.registeredFields.examTargetTag &&
        formStore.registeredFields.examTargetTag.count === 1 &&
        (forceViewError.examTargetTag ||
          (!tagData || Object.keys(tagData).length === 0) ||
          (formStore.fields && formStore.fields.examTargetTag && formStore.fields.examTargetTag.touched))
      ) {
        mustApply++;

        // 대상자 태그 선택 여부 체크
        if (formStore.values && formStore.values.examTargetTag && Array.isArray(formStore.values.examTargetTag)) {
          targetSelectCount += formStore.values.examTargetTag.length;
        }
      }
      if (
        forceViewError.examTargetEmail ||
        (formStore.fields && formStore.fields.examTargetEmail && formStore.fields.examTargetEmail.touched)
      ) {
        mustApply++;
        if (formStore.values && formStore.values.examTargetEmail && Array.isArray(formStore.values.examTargetEmail)) {
          targetSelectCount += formStore.values.examTargetEmail.length;
        }
      }

      if (this.targetSelected || mustApply === 2 || targetSelectCount > 0) {
        this.targetSelected = true;
        this.setState({ targetSelectCount });
      }

      if (formStore.values.examTargetTag !== this.props.formStore.values.examTargetTag) {
        this.props.initExamLicense();
      }
    } else if (step === 4 && formStore) {
      let templateSelectCount = 0;
      // 템플릿 선택 여부 체크
      if (formStore.values && formStore.values.examTemplate && Array.isArray(formStore.values.examTemplate)) {
        templateSelectCount += formStore.values.examTemplate.length;
        this.setState({ templateSelectCount });
      }
    } else {
      //
    }
  }

  // 악성파일 화면 잠금 날짜 변경
  onChangeScreenDate = (e, date) => {
    if (!!!date) {
      return false;
    }

    date
      .hour(0)
      .minute(0)
      .second(0);

    this.setState({
      attachScreenLockDate: date
    });
  };

  // 템플릿 선택
  setSelectTemplate = data => {
    this.setState(data);
  };

  // 태그 전부 삭제
  handleTagsInputRemoveAll = () => {
    if (this.tagsInputRef) {
      this.tagsInputRef.props.onChange([]);
    }
  };

  // 훈련 시작 일자
  handleDatePickerOnChangeStart = (e, date) => {
    if (!!!date) {
      return false;
    }

    date
      .hour(0)
      .minute(0)
      .second(0);

    const dateObj = { startDate: date.unix() };

    if (!this.state.endDate) {
      dateObj.endDate = moment.unix(dateObj.startDate + 86400 * 2 - 1);
    }

    dateObj.startDate = moment.unix(dateObj.startDate);

    if (
      this.state.startDate &&
      this.state.endDate &&
      this.state.startDate.unix() + 86400 * 2 - 1 > this.state.endDate.unix()
    ) {
      // 시작 날짜를 종료 날짜 이후로 선택한 경우
      // 종료 날짜를 초기화 해준다.
      dateObj.endDate = null;
      // 악성파일 화면 잠금 일시도 초기화
      dateObj.attachScreenLockDate = null;
    }

    this.setState(dateObj);
  };

  // 훈련 종료 일자
  handleDatePickerOnChangeEnd = (e, date) => {
    if (!!!date) {
      return false;
    }

    date
      .hour(23)
      .minute(59)
      .second(59);

    this.setState({
      endDate: date,
      attachScreenLockDate: null
    });
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    const { startDate, endDate } = this.state;
    const { step, loading, formStore, validationInfo, fieldInfo, navigatePage, invalid, examSystemUrl } = this.props;
    const {
      handleDatePickerOnChangeStart,
      handleDatePickerOnChangeEnd,
      handleTagsInputRemoveAll,
      onChangeScreenDate
    } = this;
    let content = null;

    if (step === 2) {
      content = (
        <StartExamWizardContentStep2
          formStore={formStore}
          fieldInfo={fieldInfo}
          startDate={startDate}
          endDate={endDate}
          handleDatePickerOnChangeStart={handleDatePickerOnChangeStart}
          handleDatePickerOnChangeEnd={handleDatePickerOnChangeEnd}
        />
      );
    } else if (step === 3) {
      const { tagData, initTargetTags, examPrepareData } = this.props;

      content = (
        <StartExamWizardContentStep3
          loading={loading}
          loadingTargetTag={this.state.loadingTargetTag}
          targetSelectCount={this.state.targetSelectCount}
          formStore={formStore}
          fieldInfo={fieldInfo}
          tagData={tagData}
          initTargetTags={initTargetTags}
          licenseResult={this.props.licenseResult}
          examPrepareData={examPrepareData}
          invalid={invalid}
        />
      );
    } else if (step === 4) {
      const { templateData, initTemplates, templateAttach, templateAttachIndex } = this.props;

      content = (
        <StartExamWizardContentStep4
          loadingTemplate={this.state.loadingTemplate}
          templateSelectCount={this.state.templateSelectCount}
          isAttachScreenView={this.state.isAttachScreenView}
          attachScreenLockDate={this.state.attachScreenLockDate}
          endDate={endDate}
          onChangeScreenDate={onChangeScreenDate}
          formStore={formStore}
          fieldInfo={fieldInfo}
          templateData={templateData}
          initTemplates={initTemplates}
          templateAttach={templateAttach}
          templateAttachIndex={templateAttachIndex}
          setSelectTemplate={this.setSelectTemplate}
          licenseResult={this.props.licenseResult}
          examSystemUrl={examSystemUrl}
        />
      );
    } else if (step === 5) {
      const { examFail, examResultData, moveExamResult } = this.props;

      content = (
        <StartExamWizardContentStep5
          examFail={examFail}
          examResultData={examResultData}
          navigatePage={navigatePage}
          moveExamResult={moveExamResult}
        />
      );
    } else {
      // 1 페이지 환경검사
      const { examPrepareData } = this.props;

      content = (
        <StartExamWizardContentStep1
          examPrepareData={examPrepareData}
          navigatePage={navigatePage}
          reactivateValidate={this.state.reactivateValidate}
        />
      );
    }

    const loadingText = [
      // loading 문구
      defineMessages(formatMessage({ id: 'StartExamWizardContent_1', defaultMessage: '설정 검사중...' })),
      '',
      defineMessages(formatMessage({ id: 'StartExamWizardContent_3', defaultMessage: '대상 정보 로딩중...' })),
      defineMessages(formatMessage({ id: 'StartExamWizardContent_4', defaultMessage: '양식 확인 중...' })),
      defineMessages(formatMessage({ id: 'StartExamWizardContent_5', defaultMessage: '훈련 실행중...' }))
    ];

    return (
      <div className={cx('start-exam-wizard-step-box', { complate: step === 5 })}>
        <Loading active={loading} content={loadingText[step - 1]} />
        {content}
        {validationInfo}
      </div>
    );
  }
}

StartExamWizardContent.propTypes = {
  step: PropTypes.number
};
StartExamWizardContent.defaultProps = {
  step: 1
};

const mapStateToProps = state => ({
  templateAttach: state.templateAttach.getIn(['data', 'success']),
  templateAttachIndex: state.templateAttach.get('listIndexByNo')
});

export default connect(mapStateToProps)(injectIntl(StartExamWizardContent));



// WEBPACK FOOTER //
// ./src/script/components/exam-start/StartExamWizardContent.js